module.exports = __webpack_public_path__ + "img/DSC_6266.35b6a76d.jpg";